export enum AttachmentComponentType {
  File,
  Link,
}
